module.exports = __webpack_public_path__ + "media/images/shared/univ-cal-2b69b0a42ccc669e4ca0bf9812a7cfdb271629baf1103d0a18967b525be10cfa.png";